// Lektoři GAVITO technic. Fotky jsou hostované lokálně v /public/images/lecturers.
export const LECTURER_IMG = "/images/lecturers/";

export const lecturers = [
  { id: "jan-c", name: "Jan C.", img: "crhonek.jpg" },
  { id: "michaela-h", name: "Michaela H.", img: "hulkova.jpg" },
  { id: "lucie-k", name: "Lucie K.", img: "kucharova.jpg" },
  { id: "dominika-v", name: "Dominika V.", img: "vanatkova.jpg" },
  { id: "jana-k", name: "Jana K.", img: null, initials: "JK" },
  { id: "michal-o", name: "Michal O.", img: "ondruska.jpg" },
  { id: "karel-j", name: "Karel J.", img: "jilek.jpg" },
  { id: "zuzana-c", name: "Zuzana C.", img: "zuzka.jpg" },
  { id: "milos-l", name: "Miloš L.", img: "lanc.jpg" },
  { id: "cestmir-s", name: "Čestmír Š.", img: "stastny.jpg" },
  { id: "lenka-t", name: "Lenka T.", img: "trckova.jpg" },
  { id: "veronika-v", name: "Veronika V.", img: "veselousova.jpg" },
  { id: "jana-z", name: "Jana Ž.", img: "zackova.jpg" },
  { id: "dominika-s", name: "Dominika S.", img: "dominika-s.jpg" },
];
